import { BootstrapComponent } from './BootstrapComponent';

export class StaticComponent extends BootstrapComponent{
	get components(){
		return this.bootstrap.components;
	}
	get viewport(){
		return this.bootstrap.viewport;
	}
	get animator(){
		return this.bootstrap.animator;
	}
}